import { Button, Input } from 'antd';
import { Send } from 'lucide-react';

interface MessageInputProps {
  input: string;
  isProcessing: boolean;
  disabled: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
  onSend: () => void;
}

export function MessageInput({
  input,
  isProcessing,
  disabled,
  placeholder,
  onChange,
  onSend,
}: MessageInputProps) {
  return (
    <div className="flex gap-2 items-center">
      <Input.TextArea
        value={input}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey && !isProcessing) {
            e.preventDefault();
            onSend();
          }
        }}
        disabled={disabled || isProcessing}
        placeholder={
          isProcessing
            ? 'Processing...'
            : placeholder || 'Enter a dish description or recipe'
        }
        autoSize={{ minRows: 1, maxRows: 6 }}
        className="flex-1 min-h-[44px]"
        size="large"
      />
      <Button
        type="primary"
        shape="circle"
        icon={<Send className="!w-[20px] !h-[20px]" />}
        onClick={onSend}
        disabled={!input.trim() || isProcessing || disabled}
        size="large"
        className="inline-flex items-center justify-center !p-0 [&_.ant-btn-icon]:flex [&_.ant-btn-icon]:items-center [&_.ant-btn-icon]:justify-center"
      />
    </div>
  );
}
